import { useEffect, useState } from 'react';
import { getRequestAsync } from '../helpers/apiHandler';

const useFBAuthenticated = (accessToken) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const checkAuthToken = async () => {
      if (!accessToken?.token) {
        if (isMounted) {
          setIsAuthenticated(false);
          setIsLoading(false);
        }
        return;
      }

      try {
        const payload = {
          headers: { Authorization: accessToken.token },
          signal: controller.signal,
        };

        const response = await getRequestAsync('/v2/whatsapp/fb-auth', payload);

        if (isMounted) {
          setIsAuthenticated(response.success || false);
          setIsLoading(false);
          setError(null);
        }
      } catch (error) {
        if (isMounted) {
          console.error('FB Auth check failed:', error);
          setIsAuthenticated(false);
          setIsLoading(false);
          setError(error);
        }
      }
    };

    setIsLoading(true);
    checkAuthToken();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [accessToken?.token]);

  return { isAuthenticated, isLoading, error };
};

export default useFBAuthenticated;
